import React from 'react';
import useDocumentMeta from './useDocumentMeta';

function Privacy() {
    useDocumentMeta({
        title: 'Privacy Policy | Yay Fun, Inc.',
        description: 'How Yay Fun, Inc. collects and uses information on yayfuninc.com.',
        path: '/privacy',
    });

    return (
        <section className="legal" id="legal">
            <div className="container legal__body">
                <h1>Privacy Policy</h1>
                <p className="legal__updated">Last updated: October 15, 2026</p>

                <p>
                    Yay Fun, Inc. (“Yay Fun,” “we,” “us”) builds software products. This policy explains
                    what information is collected when you visit yayfuninc.com and how it is used.
                </p>

                <h2>Information we collect</h2>
                <p>
                    This site does not ask you for any personal information. We don’t have user accounts,
                    forms, or newsletters on yayfuninc.com.
                </p>

                <h2>Analytics</h2>
                <p>
                    We use Google Analytics to understand how visitors use our site, such as which pages
                    are viewed and how people find us. Google Analytics uses cookies and collects
                    information like your browser type, device, and approximate location. You can opt out
                    using the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics opt-out browser add-on</a>.
                </p>

                <h2>How we share information</h2>
                <p>
                    We do not sell personal information. Information collected through this site is shared
                    only with the service providers that help us run it, such as our hosting and analytics
                    providers, or when required by law.
                </p>

                <h2>Our products</h2>
                <p>
                    This policy covers yayfuninc.com. Our products, such as PokeSwift and Social Bellow,
                    may have their own privacy policies, which apply when you use those products.
                </p>

                <h2>Changes</h2>
                <p>
                    We may update this policy from time to time. The date above shows when it was last changed.
                </p>

                <h2>Contact us</h2>
                <p>
                    Questions about this policy? Email <a href="mailto:contact@yayfuninc.com">contact@yayfuninc.com</a> or write to:
                </p>
                <address>
                    Yay Fun, Inc.<br />
                    3616 Far West Blvd 117-414<br />
                    Austin, TX 78731
                </address>
            </div>
        </section>
    )
}

export default Privacy
